import $ from 'jquery';
import 'slick-carousel'

export default class ReviewCarousel {
    constructor() {
        if (!$('.review-carousel__slick').hasClass('slick-initialized')) {
            $('.review-carousel__slick').slick({
                arrows: false,
                centerMode: true,
                slidesToShow: 1,
                centerPadding: '5%',
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                mobileFirst: false,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '5%'
                    }
                }, {
                    breakpoint: 99999,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: '24%'
                    }
                }]
            }).slick('resize');
        }
    }
}

new ReviewCarousel();